import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { AppService } from '../app.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-lab',
  standalone: false,
  templateUrl: './lab.component.html',
  styleUrl: './lab.component.css'
})
export class LabComponent {

  apiKey: any;
  userKey: string = '';
  workspaceName: any;
  users: any = [];
  statements: any = [];
  statement:any;
  txt: any;
  stxt: any;
  loading: boolean = false
  statementControl = new FormControl("", [Validators.required]);

  constructor(
    public appService: AppService,
    public router: Router,
  ) {}

  ngOnInit(): void {
    this.getprofiles();
  }

  async sendMessage(){
    this.loading = true;
    
    try {
      const wsJson = this.appService.get("xdbc.workspace");

      if (wsJson) {
        const ws = JSON.parse(wsJson);
        this.apiKey = ws.apiKey;
        this.workspaceName = ws.workspaceName;
      }

      this.statement = this.statementControl.value;

      const activationPayload = {
        userKey:this.userKey,
        statement:this.statement,
        routeType:"UI_SESSION"
      };

      const signatureData = await this.appService.wssign(
        activationPayload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        activationPayload,
        "memory/predict",
        this.apiKey,
        signature
      );
      this.statementControl.reset();
      if (response && response.status == "Success") {
        this.statements = response;
        this.stxt = response.message;
        this.loading = false;
        
      } else {
        throw new Error(response?.message);
      }
    } catch (error: any) {
      // console.error("Error in submitPrivateKey:", error);
      this.stxt = "Activation failed: " + (error.message || "Unknown error");
    }
  }

  onUserChange(event: MatSelectChange): void {
    this.userKey = event.value;
    // console.log('this.userKeythis.userKey',this.userKey);
  }

async getprofiles() {

    try {
      const wsJson = this.appService.get("xdbc.workspace");

    if (wsJson !== undefined && typeof wsJson === 'string' && wsJson.trim() !== '' && wsJson !== 'undefined') {
      try {
        const ws = JSON.parse(wsJson);
        this.apiKey = ws.apiKey;
        this.workspaceName = ws.workspaceName;
      } catch (err) {
        console.error('Invalid JSON:', err);
      }
    }  
      const activationPayload = {
        routeType:"UI_SESSION"
      };

      const signatureData = await this.appService.wssign(
        activationPayload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        activationPayload,
        "auth/list-profile",
        this.apiKey,
        signature
      );

      if (response && response.status == "Success") {
        this.users = response;
        this.txt = response.message;
      } else {
        throw new Error(response?.message);
      }
    } catch (error: any) {
      // console.error("Error in submitPrivateKey:", error);
      this.txt = "Activation failed: " + (error.message || "Unknown error");
    }
  }

}
